export default {
  restaurantAdmins: [],
  restaurantAdmin: undefined,
};
